import { legacyArtifact } from '@/helpers/legacyArtifact.helpers';
import type { ToolCallContent } from '@/types/messages';
import type {
  Artifact,
  Clarification,
  Plan,
  ToolView,
} from '@/types/artifacts.types';
import type { ToolCallArtifact } from '@/types/toolViews.types';

/** How each kind reads its versions; null for a version it does not know. */
export const ARTIFACT_READERS: {
  [K in Artifact['kind']]: (
    raw: ToolCallArtifact,
  ) => Extract<Artifact, { kind: K }> | null;
} = {
  tool_view: (raw) => (raw.version === 2 ? (raw as ToolView) : null),
  clarification: (raw) =>
    raw.version === 1 ? (raw as Clarification) : null,
  plan: (raw) => (raw.version === 1 ? (raw as Plan) : null),
};

const isKnownKind = (kind: string): kind is Artifact['kind'] =>
  Object.prototype.hasOwnProperty.call(ARTIFACT_READERS, kind);

/**
 * A block's artifact at its kind's current version; null for a kind or
 * version the UI does not know, which draws the title-only row.
 */
export function readArtifact(
  raw: ToolCallArtifact | null | undefined,
): Artifact | null {
  if (!raw || !isKnownKind(raw.kind)) return null;
  return ARTIFACT_READERS[raw.kind](raw);
}

/** What a call draws: its artifact, or the legacy reader's when it has none. */
export const callArtifact = (call: ToolCallContent): Artifact | null =>
  call.artifact == null ? legacyArtifact(call) : readArtifact(call.artifact);
